module.exports = __webpack_public_path__ + "img/404.d67a923d.png";